export default class ApplicationDefinition {
  static owner(app, app_owner_role_id): string {
    const appOwnerShare = app.rootFolder.shares.find(share => share.role_ids.includes(app_owner_role_id))
    return appOwnerShare?.reference_id
  }
}
